import { render, staticRenderFns } from "./C1R_S12.vue?vue&type=template&id=67c86b4f&scoped=true"
import script from "./C1R_S12.vue?vue&type=script&lang=js"
export * from "./C1R_S12.vue?vue&type=script&lang=js"
import style0 from "./C1R_S12.vue?vue&type=style&index=0&id=67c86b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c86b4f",
  null
  
)

export default component.exports